import createContext from "@common/utils/createContext";

export const { context, useContext, Provider, Consumer } = createContext();

export default context;
